module.exports={close:"닫기",error:"오류",info:"정보",success:"성공",warning:"경고"};